export const RENAME_PROJECTS_FOLDER = 'RENAME_PROJECTS_FOLDER'
